
import React from "react";
import { Button } from "@/components/ui/button";
import { Check, Clock, Download, ShoppingCart } from "lucide-react";

interface AgentPurchaseButtonProps {
  purchasing: boolean;
  purchaseSuccess: boolean;
  pricingModel: string;
  handlePurchase: () => void;
}

export const AgentPurchaseButton: React.FC<AgentPurchaseButtonProps> = ({
  purchasing,
  purchaseSuccess,
  pricingModel,
  handlePurchase,
}) => {
  const getButtonText = () => {
    if (purchasing) {
      return (
        <span className="flex items-center gap-2">
          <Clock className="h-4 w-4 animate-spin" />
          Processing...
        </span>
      );
    }

    if (pricingModel === "free") {
      return (
        <span className="flex items-center gap-2">
          <Download className="h-4 w-4" />
          Download
        </span>
      );
    }

    return (
      <span className="flex items-center gap-2">
        <ShoppingCart className="h-4 w-4" />
        Buy
      </span>
    );
  };

  return purchaseSuccess ? (
    <Button 
      className="w-full bg-green-600 hover:bg-green-700 text-white flex items-center justify-center gap-2"
      disabled
    >
      <Check className="h-4 w-4" />
      {pricingModel === "free" ? "Downloaded" : "Purchased"}
    </Button>
  ) : (
    <Button 
      className="w-full flex items-center justify-center gap-2"
      onClick={handlePurchase}
      disabled={purchasing}
      aria-busy={purchasing}
    >
      {getButtonText()}
    </Button>
  );
};
